
    import Vue from "vue";
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";

    @Component
    export default class CardQuicklink extends Vue {
        @Prop({type: Boolean, default: false})
        removeArrow!: boolean;

        get hasIconSlot() : boolean {
            return !!this.$scopedSlots.icon;
        }

        get hasDescriptionSlot() : boolean {
            return !!this.$scopedSlots.description;
        }
    }
